import { getDateNow } from 'odfjell-date-time-utils/dateTimeUtils';
import useAppFeature from './useAppFeature';
import { AppFeatureEnum } from 'src/enums/appFeatureEnum';
import { StowagePlan } from 'src/types/ViewModel/Stowage/StowagePlan';
import { useVesselStore } from 'src/context/VesselContext';

export default () => {
    const { isFeatureEnabled } = useAppFeature();
    const { selectedVessel } = useVesselStore();

    // Returns true when StowageIntegration is enabled but the stowage plan hasn't loaded yet,
    // indicating the caller should wait. Simple mode vessels are exempt because their AOL data
    // can be built from IMOS rotation + events without a stowage plan.
    const checkLoadedStowageIntegration = (imoNumber: number, loadedMasterStowagePlan: StowagePlan): boolean =>
        isFeatureEnabled({ featureEnum: AppFeatureEnum.StowageIntegration, imoNumber, date: getDateNow() }) &&
        !loadedMasterStowagePlan &&
        !selectedVessel?.hasOrcaWebSimpleMode;

    return {
        checkLoadedStowageIntegration,
    };
};
